export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_ENV_APP_ID ? process.env.REACT_APP_ENV_APP_ID : "",
        authority: "https://login.microsoftonline.com/a946db45-98b6-4631-9b56-6934b1be8b49",
        redirectUri: process.env.REACT_APP_ENV_REDIRECTURL ? process.env.REACT_APP_ENV_REDIRECTURL : "",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        iframeHashTimeout: 10000,
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
    //scopes: ["api://687c8a62-8d78-40a1-b3a7-9f2699a6247d/.default"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
//export const graphConfig = {
//    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
//};